export default __webpack_public_path__ + "static/media/elementalfury.4a6fb622.png";